import React, { useState } from 'react';
import { Button, Card } from './UI';

const Llm: React.FC = () => {
  const [fileContent, setFileContent] = useState('');
  const [fileName, setFileName] = useState('');
  const [prompt, setPrompt] = useState(`"Das Dokument kann auf Deutsch, Englisch, Französisch oder Italienisch sein.\n"
        "Analysiere den Inhalt sprachunabhängig und priorisiere wie folgt:\n\n"
        "🟢 STRATEGIE 1: SCHWEIZER QR-RECHNUNGEN & ZAHLTEIL (Swiss QR Bill)\n"
        "Suche nach dem Abschnitt **'Zahlteil'** oder **'Konto / Zahlbar an'** (bzw. 'Account / Payable to').\n"
        "Dieser Abschnitt hat die HÖCHSTE DATENQUALITÄT. Nutze ihn wie folgt:\n"
        "   1. **Lieferant (Supplier) - KRITISCH:**\n"
        "      - Gehe zum Abschnitt unter **'Konto / Zahlbar an'**.\n"
        "      - Die Zeile direkt UNTER der IBAN (CH...) enthält den **korrekten, offiziellen Firmennamen**.\n"
        "      - **NIMM DIESEN NAMEN ZEICHENGENAU.**\n"
        "      - Ignoriere Logos, Slogans oder Texte am oberen Blattrand (wie 'Bauen mit...'), da diese oft Marketing-Text enthalten.\n"
        "   2. **Zahlung:**\n"
        "      - Nimm Währung, Betrag, IBAN und Referenznummer direkt aus diesem Block.\n"
        "   3. **Kunde:**\n"
        "      - Steht unter **'Zahlbar durch'** (DE) / 'Payable by' (EN).\n"
        "   4. **Zusatz-Infos:**\n"
        "      - Steht unter 'Zusätzliche Informationen'. Nutze dies für Rechnungsnummern, falls oben nicht eindeutig.\n"
        "   -> Falls ein injizierter Block '--- SCHWEIZER QR-CODE DATEN ---' existiert, nutze diesen bevorzugt.\n\n"
        "🔴 STRATEGIE 2: AUSLÄNDISCHE ODER STANDARD-RECHNUNGEN\n"
        "-> FALLS KEIN 'SCHWEIZER QR-CODE' Block vorhanden ist:\n"
        "   - Suche visuell nach dem 'Zahlteil' oder Bankdaten-Abschnitt:\n"
        "    - Priorisiere den Abschnitt 'Konto / Zahlbar an' (DE), 'Account / Payable to' (EN).\n"
        "    - Nimm die IBAN und BIC/SWIFT aus diesem Abschnitt.\n\n"
        "   - Extrahiere den Lieferanten-Namen vom Kopf der Rechnung, aber achte auf Rechtsformen (AG, GmbH), um Slogans zu vermeiden.\n\n"
        "Allgemeine Extraktionsregeln:\n"
        "1. Rechnungsnummer (invoice_number): Suche nach:\n"
        "   - DE: 'Rechnung Nr.', 'Rechnungsnummer', 'Beleg-Nr.'\n"
        "   - EN: 'Invoice No', 'Invoice #'\n"
        "   - FR: 'Facture n°', 'No de facture'\n"
        "   - IT: 'Fattura n.', 'Numero Fattura'\n"
        "2. Bestellnummer / Kundenreferenz (order_number) - Unterscheide dies von der Rechnungsnummer!\n"
        "   - DE: 'Ihre Referenz', 'Bestellnummer', 'Bestellung', 'Auftrag Nr.', 'Unser Zeichen'\n"
        "   - EN: 'Order No', 'Purchase Order', 'PO #', 'Your Reference', 'Ref'\n"
        "   - FR: 'Numéro de commande', 'Réf. commande', 'Votre référence', 'Commande'\n"
        "   - IT: 'Numero ordine', 'N. ordine', 'Riferimento', 'Vostro riferimento'\n"
        "3. Datum (invoice_date): Format YYYY-MM-DD.\n"
        "   - 'delivery_date': Suche nach 'Leistungsdatum', 'Lieferdatum' oder Datumsbereichen (Zeitraum).\n"
        "4. Lieferant (supplier) und Kunde (customer):\n"
        "   - **Adress-Zerlegung:** Zerlege Adressen zwingend in: Strasse/Nr ('street'), PLZ ('zip_code'), Ort ('city'), Land ('country').\n"
        "   - **ACHTUNG PLZ:** Achte strikt darauf, die Postleitzahl (z.B. '7032') in das Feld 'zip_code' und den Ort (z.B. 'Landquart') in das Feld 'city' zu trennen!\n"
        "   - 'vendor_number' & 'customer_number': Suche nach Identifikationsnummern (Kundennummer, Lieferantennummer).\n"
        "   - 'reference_number' (im Supplier-Block): Suche nach QR-Referenz (27-stellig) oder 'Zahlungsreferenz'.\n"
        "5. Beträge (amounts):\n"
        "   - Netto, Liste der Steuersätze ('vat_breakdown') und Total.\n"
        "   - Trigger: 'Gesamtbetrag' (DE), 'Total Amount' (EN), 'Total TTC' (FR), 'Totale' (IT).\n"
        "   - 'total_amount' muss > 0.0 sein.\n"
        "6. Positionen (items) - WICHTIG:\n"
        "   - **UNTERSCHEIDE ZUSAMMENFASSUNG VS. DETAILS:**\n"
        "     - Ignoriere Blöcke mit Titeln wie:\n"
        "       - DE: 'Zusammenstellung', 'Zusammenfassung', 'Totalisierung', 'Übertrag'\n"
        "       - EN: 'Summary', 'Overview', 'Totalization', 'Carry over'\n"
        "       - FR: 'Récapitulatif', 'Résumé', 'Sommaire', 'Report'\n"
        "       - IT: 'Riepilogo', 'Sommario', 'Riassunto', 'Riporto'\n"
        "     - Suche stattdessen nach der **detaillierten Leistungsaufstellung** auf den Folgeseiten.\n"
        "   - 'item_no': Extrahiere Pos-Nr. (z.B. '10', '1.1') oder Artikel-Code (z.B. 'R1112').\n"
        "   - 'vat_rate': Extrahiere den MwSt-Satz pro Zeile, falls angegeben.\n"
        "   - 'unit': Normalisiere Einheiten (Pcs/Pezzi -> Stk, Hours/Heures -> h).\n"
        "   - **Rabatte (Discounts):** Prüfe pro Position auf Abzüge.\n"
        "     - Suche nach: 'Rabatt', 'Skonto', 'Nachlass' (DE) / 'Discount', 'Rebate' (EN) / 'Remise', 'Rabais' (FR) / 'Sconto' (IT).\n"
        "     - Extrahiere Prozentwert in 'discount_rate' oder Betrag in 'discount_amount'.\n"
        "     - **WICHTIG:** Das Feld 'total' muss der ENDPREIS der Position sein (also: Menge * Preis - Rabatt).\n"
        "7. ZAHLUNGSBEDINGUNGEN (payment_terms):\n"
        "   - Suche nach Sätzen wie 'Zahlbar innert 30 Tagen', '10 Tage 2% Skonto', 'fällig am'.\n"
        "   - 'due_days': Maximale Tage bis Fälligkeit (z.B. '30 Tage netto' -> 30).\n"
        "   - 'discount_days': Frist für Skonto-Abzug (z.B. '10 Tage 2% Skonto' -> 10).\n"
        "   - 'discount_percentage': Skonto-Satz als Zahl (z.B. '2%' -> 2.0).\n"
        "   - 'raw_text': Der vollständige, ungeschnittene Satz der Zahlungsbedingung.\n"
        "8. VALIDIERUNG & REPORT (Erweitert):\n"
        "   Führe bevor du das JSON erstellst folgende Rechnungen durch und fülle 'validation_report':\n"
        "   a) **Math Check (Netto + MwSt = Brutto):**\n"
        "      - Rechne: 'net_amount' + Summe 'vat_breakdown'. Vergleiche mit 'total_amount'.\n"
        "      - Toleranz +/- 0.05 erlaubt.\n"
        "   b) **Line Items Check (Summe Positionen = Netto):**\n"
        "      - Summiere alle 'total' Werte im 'items' Array (diese sind bereits rabattiert).\n"
        "      - Vergleiche die Summe mit 'amounts.net_amount' (oder 'amounts.total_amount' bei Kleinunternehmern).\n"
        "      - Schreibe das Ergebnis in den Report.\n"
        "   c) **Missing Fields:** Liste fehlende Pflichtfelder (Rechnungsnummer, Datum, Total) auf.\n"
        "   d) **Summary:** Verfasse eine kurze Zusammenfassung ('message') in der **Sprache des Dokuments**."
        Give me the output in below json format
        {
  "currency": "",
  "fileName": ,
  "documentNumber": "",
  "documentType": "",
  "billerName": "",
  "billerCity": "",
  "billerPostalCode": "",
  "billerCountryCode": "",
  "billerId": "",
  "recipientName": "",
  "recipientCity": "",
  "recipientPostalCode": "",
  "recipientCountryCode": "",
  "invoiceDate": "",
  "dueDate": "",
  "iban": "",
  "referenceStructured": "",
  "referenceType": "",
  "amount": "",
  "billRecipientEmail": ,
  "billRecipientId": ,
  "emailDeliveryAddress": ,
  "printPageCount": 
}`);
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFileName(file.name);
    setError('');

    try {
      const text = await file.text();
      setFileContent(text);
    } catch (err: any) {
      setError(err?.message || 'Unable to read file.');
    }
  };

  const fileToBase64 = (text: string): string => {
    return btoa(unescape(encodeURIComponent(text)));
  };

  const handleSubmit = async () => {
    setError('');
    setResult('');
    setLoading(true);

    try {
      const fileBase64 = fileToBase64(fileContent);

      const response = await fetch('https://iomarket.gate2b.net/api/v1/llm/process/test', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ file: fileBase64, prompt }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || response.statusText || 'API call failed');
      }

      const data = await response.json();
      const value = typeof data.result === 'string' ? data.result : JSON.stringify(data.result, null, 2);
      setResult(value);
    } catch (err: any) {
      setError(err?.message || 'Unable to call the API.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="p-6 space-y-4 bg-white dark:bg-[#161616] border border-gray-200 dark:border-[#393939]">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-lg font-bold text-[#161616] dark:text-white">LLM Assistant</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">Upload a file, enter a prompt, then click PARSE button.</p>
        </div>
        <span className="text-[10px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-500">AI</span>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200">File</label>
          <div className="flex items-center gap-3">
            <input
              type="file"
              onChange={handleFileSelect}
              className="w-full text-sm text-gray-500 file:mr-4 file:px-4 file:py-2 file:rounded-lg file:border-0 file:bg-[#474D22] file:text-white file:font-semibold file:cursor-pointer hover:file:bg-[#3A3F1C] dark:file:bg-brand-medium dark:file:hover:bg-brand-dark"
            />
          </div>
          {fileContent && (
            <p className="text-xs text-green-600 dark:text-green-400">✓ File loaded ({(fileContent.length / 1024).toFixed(1)} KB)</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200">Prompt</label>
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Enter your prompt here"
            rows={18}
            className="w-full min-h-[500px] resize-none rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 outline-none transition focus:border-[#474D22] focus:bg-white dark:border-[#393939] dark:bg-[#111111] dark:text-white dark:focus:bg-[#161616]"
          />
        </div>

        <div className="flex flex-col gap-3">
          <Button
            type="button"
            variant="primary"
            size="md"
            onClick={handleSubmit}
            disabled={loading || !fileContent || !prompt}
            className="w-full"
          >
            {loading ? 'Calling API...' : 'Parse'}
          </Button>

          {!fileContent || !prompt ? (
            <p className="text-sm text-yellow-600 dark:text-yellow-400">Please upload a file and enter a prompt</p>
          ) : error ? (
            <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
          ) : null}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200">Result</label>
          <textarea
            value={result}
            readOnly
            placeholder="API result appears here"
            rows={10}
            className="w-full min-h-[220px] resize-none rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 outline-none transition focus:border-[#474D22] focus:bg-white dark:border-[#393939] dark:bg-[#111111] dark:text-white dark:focus:bg-[#161616]"
          />
        </div>
      </div>
    </Card>
  );
};

export default Llm;

